import { webApi } from 'src/services/api/config'
import { AxiosResponse } from 'axios'
import { LatestNew } from 'src/store/ducks/latestNews/latestNews.types'
import { ITag, IPostTag, IGetCareers } from './interfaces'

const baseRoute = 'api/site/news'

/**
 * Gets a post
 * @param id post id
 * @returns The post
 */
export const getPost = async (id: number): Promise<AxiosResponse> => {
  return await webApi.get(`${baseRoute}/${id}`)
}

/**
 * Gets a post category
 * @param id postCategory id
 * @returns The post category
 */
export const getPostCategory = async (id: number): Promise<AxiosResponse> => {
  return await webApi.get(`${baseRoute}/categories/${id}`)
}

/**
 * Gets all tags
 * @returns list of tags
 */
export const getTags = async (): Promise<AxiosResponse<ITag[]>> => {
  return await webApi.get(`${baseRoute}/tags`)
}

/**
 * Gets all tags of a post
 * @param postId post id
 * @returns list of tags
 */
export const getPostTags = async (
  postId: number
): Promise<AxiosResponse<IPostTag[]>> => {
  return await webApi.get(`${baseRoute}/tags/${postId}`)
}

export const getCareers = (status = '') => {
  const statusQuery = status ? `?status=${status}` : ''
  return webApi
    .get<IGetCareers[]>(`${baseRoute}/careers${statusQuery}`)
    .then((response) => response.data)
}

/**
 * Gets the most recent posts
 * @returns The most recent posts
 */
export const getLatestNews = async (): Promise<AxiosResponse<LatestNew[]>> => {
  return webApi.get(`${baseRoute}/latest`)
}
